<template>
  <li><slot></slot></li>
</template>

<script>
export default {
  props: ['text'],
};
</script>

<style></style>
